import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { AdmobComponent } from '@app/features/monetization/admob/admob.component';
import { UIState } from '@app/ui/states/ui.state';
import { TranslatePipe } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-monetization-section',
  templateUrl: './monetization-section.component.html',
  styleUrl: './monetization-section.component.scss',
  standalone: true,
  imports: [AdmobComponent, AsyncPipe, TranslatePipe],
})
export class MonetizationSectionComponent {
  @Select(UIState.isCreationProcess) isCreationProcess$: Observable<boolean>;
}
